import {doGet }  from './FetchWrapper';

export const list = () => {
    return doGet(`/api/?event=medicalDataCategory.list`)
};

